import { z } from 'zod'

import { categoryProperties } from './BaseModels'

export const categoryParser = z.object(categoryProperties)

export type Category = z.infer<typeof categoryParser>
